import SxSocket from '@/api/socket'
import { IMessage } from '@stomp/stompjs'

export interface storeOptsType {
	modules: any;
	state: any;
	mutations: any;
	actions: any;
	getters: any;
}

export const modules = {

}
export const state = function () {
	return {
		analyzedResult: [],
		acpointValue: [],
		deviceStatus: [],
		acpointAlarm: [],
		protocolFrame: null,
		softwareUpgrade: null,
		socketClient: null,
	}
}
export const mutations = {
	subscribeData(state) {
		if (state.socketClient) {
			try {
				state.socketClient.deactivate()
			} catch (e) { }
		}
		state.socketClient = null
		let socket = SxSocket()
		socket.then((res: any) => {
			state.socketClient = res
			// console.log('订阅数据触发--------------------------', res, res.counter)
			//获取socket对象
			res?.subscribe('/exchange/platform/#', (message: IMessage) => {
				const body = JSON.parse(message.body)
				switch (body.action) {
					//订阅隐患推送
					case 'patrol.result.analyzed':
						const { action, ...others } = body
						state.analyzedResult = others;
						break
					case 'front.acpoint.alarm':
						if (body.data && Array.isArray(body.data)) {
							state.acpointAlarm = [...body.data];
						}
						break
					case 'front.acpoint.value':
						state.acpointValue = body.data;
						break
					case 'front.acdevice.status':
						state.deviceStatus = body.data;
						break
					case 'protocol_frame':
						state.protocolFrame = body.message;
						break
					case 'device.upgrade.status':
						state.softwareUpgrade = body.data;
						break

				}
			})
		})
	},
}
export const actions = {
	subscribeData(obj) {
		obj.commit('subscribeData')
	},
}
export const getters = {

}



export const storeOpts: storeOptsType = {
	modules,
	state,
	mutations,
	actions,
	getters,
}
